import React, { useEffect, useState } from 'react';
import { Control, useWatch } from 'react-hook-form';
import { UseFormSetValue } from 'react-hook-form/dist/types/form';
import { classNames } from '@/lib/classNames';
import { Input, Label, TextEditor } from '@/components/basic';
import { EditResourceMultipleForm } from '@/components/resources/tabs/GeneralTabMultiple';

type Props = {
  defaultValues: EditResourceMultipleForm;
  control: Control<EditResourceMultipleForm>;
  setValue: UseFormSetValue<EditResourceMultipleForm>;
  name: 'name' | 'label' | 'description';

  label: string;
};

export function EditMultipleTextInput({
  control,
  setValue,
  name,
  label
}: Props) {
  const values = useWatch({ name: 'textBulkValues', control });
  const [edit, setEdit] = useState(false);
  useEffect(() => {
    if (edit) {
      setValue(`textBulkValues.${name}`, '#{{number:1}}');
    } else {
      setValue(`textBulkValues.${name}`, '');
    }
  }, [edit]);
  return (
    <div className="mt-4">
      <div>
        <Label className="text-base text-tertiary">
          <span className="font-bold">{label}</span>
          <button
            onClick={(ev) => {
              ev.preventDefault();
              setEdit((x) => !x);
            }}
            className="mx-2 text-sm text-gray-700 underline"
          >
            {edit ? 'Cancel edit' : 'Edit in Bulk'}
          </button>
        </Label>

        {name !== 'description' ? (
          <Input
            onChange={(ev) => {
              if (!edit) {
                ev.preventDefault();
                return;
              }
              setValue(`textBulkValues.${name}`, ev.currentTarget.value);
            }}
            readOnly={!edit}
            disabled={!edit}
            type="text"
            id={`${name}-label`}
            value={!edit ? 'Multiple values' : values[name]}
          />
        ) : edit ? (
          <div className="my-1">
            <TextEditor
              onChange={(str) => {
                if (!edit || !str) {
                  return;
                }
                setValue(`textBulkValues.${name}`, str);
              }}
              value={values[name] ?? ''}
              id={`textBulkValues.${name}-description`}
            />
          </div>
        ) : (
          <div
            className={classNames(
              !edit
                ? 'my-1 cursor-not-allowed rounded-md bg-gray-300 px-3 py-2 text-gray-900 opacity-50'
                : ''
            )}
          >
            Multiple values
          </div>
        )}
      </div>
    </div>
  );
}
